import { Route } from "react-router-dom";

import DisplayModule from "../../Modules/Admin/Screens/Module/DisplayModule.jsx";
import Module from "../../Modules/Admin/Screens/Module/Module.jsx";
import ModuleView from "../../Modules/Admin/Screens/Module/ModuleView.jsx";
import ImportModuleQuestion from "../../Modules/Admin/Screens/Module/ImportModuleQuestion.jsx";
import AdminLayout from "../../Modules/Admin/Layout";
import ModueForStudent from "../../Modules/Admin/Components/ManageClusterTabs/ModuleForStudent.jsx";
import LeetcodeCampusListing from "../../Modules/Admin/Screens/Reports/LeetcodeCampusListing.jsx";
import LeetcodeClusterListing from "../../Modules/Admin/Screens/Reports/LeetcodeClusterListing.jsx";

const ModuleRoutes = [
  <Route
    key="module"
    path="/admin/practice-lab"
    element={
      <AdminLayout>
        <DisplayModule />
      </AdminLayout>
    }
  />,
  <Route
    key="module-create"
    path="/admin/module/create"
    element={
      <AdminLayout>
        <Module />
      </AdminLayout>
    }
  />,
  <Route
    key="module-import-questions"
    path="/admin/module/import-questions"
    element={
      <AdminLayout>
        <ImportModuleQuestion />
      </AdminLayout>
    }
  />,
  <Route
    key="module-view"
    path="/admin/module/view/:id"
    element={
      <AdminLayout>
        <ModuleView />
      </AdminLayout>
    }
  />,
  <Route
    key = "module-for-student"
    path = "/module-for-student"
    element = {
      <AdminLayout>
        <ModueForStudent />
      </AdminLayout>
    }
  />,
  <Route
    key = "leetcode-report"
    path = "/admin/reports/leetcode"
    element = {
        <LeetcodeCampusListing />
    }
  />,
  <Route
    key="reports-leetcode-listing"
    path="/admin/reports/leetcode/:campusName"
    element={<LeetcodeClusterListing />}
  />
];

export default ModuleRoutes;
